"use client";
import { jsx } from "react/jsx-runtime";
import { Button } from "@nxt-costco-com/forge-components";
import { ONETRUST_BUTTON_ID, COMPONENT_NAME, ONETRUST_BUTTON_CLASS } from "./constants.js";
const OneTrustButton = ({
  entry
}) => {
  var _a, _b;
  const buttonText = (_b = (_a = entry == null ? void 0 : entry.active_state) == null ? void 0 : _a.active_state_link) == null ? void 0 : _b.title;
  return /* @__PURE__ */ jsx(
    Button,
    {
      className: ONETRUST_BUTTON_CLASS,
      "data-testid": COMPONENT_NAME,
      id: ONETRUST_BUTTON_ID,
      uniqueId: "cookie-settings",
      variant: "text-button",
      children: buttonText
    }
  );
};
export {
  OneTrustButton
};
